import {
  START_CREATING_EVENT,
  CANCEL_CREATING_EVENT,
  CREATE_EVENT
} from 'actions/Types';

export default (state = null, action) => {
  if (
    action.type === CANCEL_CREATING_EVENT ||
    action.type === `${CREATE_EVENT}_SUCCESS`
  ) {
    return null;
  }

  if (action.type === START_CREATING_EVENT) {
    return action.payload;
  }

  return state;
};
